import type { PackageSettingsMatch } from '@ms-cloudpack/common-types';
import { validateMatch } from '@ms-cloudpack/config';
import { InvalidArgumentError } from 'commander';
import semver from 'semver';

/**
 * Parse a `--match` argument, e.g. `"foo"`, `"@foo/bar"`, `"@foo/*"`, `"@foo/bar@1.2.3"`.
 */
export function parseMatch(match: string, acc: PackageSettingsMatch[] = []): PackageSettingsMatch[] {
  let name: string;
  let version: string | undefined;
  const atVersionIndex = match.indexOf('@', 1);
  if (atVersionIndex === -1) {
    name = match;
  } else {
    name = match.substring(0, atVersionIndex);
    version = match.substring(atVersionIndex + 1);
  }

  const nameStarIndex = name.indexOf('*');
  if (nameStarIndex !== -1 && nameStarIndex !== name.length - 1) {
    throw new InvalidArgumentError(
      `Invalid match string "${match}". A wildcard is only supported at the end of the name.`,
    );
  }

  if (version && !semver.validRange(version)) {
    throw new InvalidArgumentError(`Invalid match string "${match}". The version "${version}" is not valid semver.`);
  }

  const validateResult = validateMatch({ name, version });
  if (!validateResult.isValid) {
    throw new InvalidArgumentError(`Invalid match string "${match}": ${validateResult.error}`);
  }

  acc.push(version && version !== '*' ? { name, version } : name);

  return acc;
}
